<template>
<div>
  <v-list-item>
    <v-list-item-avatar>
        <v-img :src="imgSrc"></v-img>
    </v-list-item-avatar>

    <v-list-item-content>
        <v-list-item-title>{{name}}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>

  <v-divider></v-divider>
  <v-list dense>
        <v-list-item
          link
          @click="$router.push('Home').catch(err => {})"
        >
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
    </v-list>
</div>
</template>

<script>
export default {
    name:'Sidebar',
    props: [ 'name', 'imgSrc' ],
    data: () => ({ items: [
          { title: 'Home', icon: 'mdi-view-dashboard' },
          { title: 'About', icon: 'mdi-forum' },
        ],}),
}
</script>

<style>

</style>